import { ISelectorOptions } from 'components/common'

export const OutOfHoursChargeType = {
  Default: 'default',
  Rate: 'rate',
  Percent: 'percent',
} as const

export type TOutOfHoursChargeType = typeof OutOfHoursChargeType[keyof typeof OutOfHoursChargeType]

const OUT_OF_HOURS_CHARGE_TYPE_LABELS: Record<TOutOfHoursChargeType, string> = {
  [OutOfHoursChargeType.Default]: 'Default',
  [OutOfHoursChargeType.Rate]: 'Fixed amount (£)',
  [OutOfHoursChargeType.Percent]: 'Percentage (%)',
}

export const OutOfHoursChargeTypeValues: ISelectorOptions = Object.entries(
  OUT_OF_HOURS_CHARGE_TYPE_LABELS,
).map(([value, label]) => ({ value, label }))

export const resolveOutOfHoursChargeType = (customer?: {
  outOfHoursChargeRate?: number | null
  outOfHoursChargePercent?: number | null
}): TOutOfHoursChargeType =>
  customer?.outOfHoursChargePercent != null
    ? OutOfHoursChargeType.Percent
    : customer?.outOfHoursChargeRate != null
    ? OutOfHoursChargeType.Rate
    : OutOfHoursChargeType.Default
